import {
  getScheduleByScheduleUuidOptions,
  postScheduleInternalMutation,
} from "@aura-frontend/omnibus-az-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SCHEDULES_QUERY_KEY } from "../Complexes/SingleField/FieldSchedule/FieldSchedule.queries";

export const useUpdateEvent = (scheduleUuid: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    ...postScheduleInternalMutation(),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [SCHEDULES_QUERY_KEY],
          exact: false,
          refetchType: "all",
        }),
        queryClient.invalidateQueries({
          queryKey: getScheduleByScheduleUuidOptions({
            path: { scheduleUuid },
          }).queryKey,
        }),
      ]);
    },
  });

  return { updateEvent: mutateAsync, isUpdatingEvent: isPending };
};
